"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableRow = void 0;
const styles_1 = require("@mui/material/styles");
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
exports.StyledTableRow = (0, styles_1.styled)(TableRow_1.default, {
    shouldForwardProp: (prop) => prop !== "isDragging",
})(({ theme, isDragging }) => ({
    backgroundColor: isDragging ? "rgba(0, 169, 224, 0.5)" : "#f7f7f7",
    "&:nth-of-type(even)": {
        backgroundColor: theme.palette.grayScale.white,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
